import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ChoiceSelectionComponent, getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, getPhotoCaptureContextId, photoCaptureResetContextAction, photoCaptureUpdateAttachmentDataSuccessAction, getPhotoCaptureIsTermsAndConditionAccepted, photoCaptureUpdateAttachedArtifactIdSuccessAction, getPhotoCaptureAttachedArtifactIds, getPhotoCaptureAttachmentInfo, getShouldAllowMitchellIntelligent } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationAnswerList, getQuestionnaireEvaluationParentQuestionId, getIsQuestionnaireEvaluationMultiSelectAllowed } from "../../../domain/questionnaireEvaluation";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        answerList: getQuestionnaireEvaluationAnswerList(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        isMultiSelectionAllowed: getIsQuestionnaireEvaluationMultiSelectAllowed(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        isMic: getShouldAllowMitchellIntelligent(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureResetContextAction,
        photoCaptureUpdateAttachmentDataSuccessAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    }, dispatch);
};
export const ConnectedChoiceSelectionComponent = connect(mapStateToProps, mapDispatchToProps)(ChoiceSelectionComponent);
//# sourceMappingURL=ConnectedChoiceSelectionComponent.js.map